module.exports = __webpack_public_path__ + "static/media/11NEPAD11.b33eff4e.jpg";